/* Sign Studio catalogue enhancement. Native product URLs are the fallback. */
(() => {
  if (customElements.get('fp-sign-catalog')) return;

  class SignCatalog extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.items = [...this.querySelectorAll('[data-sign-product]')];
      this.list = this.querySelector('.fp-sign-catalog__items');
      this.continueLink = this.querySelector('[data-sign-continue]');
      this.isPicker = this.dataset.signCatalogMode === 'picker';
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };

      if (this.isPicker) {
        this.items.forEach((item) => {
          item.setAttribute('role', 'button');
          item.setAttribute('aria-pressed', String(item.classList.contains('is-selected')));
        });
        const initial = this.items.find((item) => item.classList.contains('is-selected')) || this.items[0];
        if (initial) this.select(initial);
      }

      this.addEventListener('click', (event) => {
        const item = event.target.closest('[data-sign-product]');
        if (this.isPicker && item && this.contains(item) && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
          event.preventDefault();
          this.select(item);
        }
        const scrollButton = event.target.closest('[data-sign-scroll]');
        if (scrollButton && this.list) {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.list.scrollBy({ left: this.list.clientWidth * 0.8 * Number(scrollButton.dataset.signScroll), behavior: reducedMotion ? 'instant' : 'smooth' });
        }
      }, options);

      this.addEventListener('keydown', (event) => {
        const item = event.target.closest('[data-sign-product]');
        if (this.isPicker && item && event.key === ' ') {
          event.preventDefault();
          this.select(item);
        }
      }, options);

      this.scrollButtons = [...this.querySelectorAll('[data-sign-scroll]')];
      if (this.list && this.scrollButtons.length) {
        const refresh = () => this.updateScrollButtons();
        this.list.addEventListener('scroll', refresh, { ...options, passive: true });
        this.observer = new ResizeObserver(refresh);
        this.observer.observe(this.list);
        this.updateScrollButtons();
      }
    }

    select(selected) {
      this.items.forEach((item) => {
        const active = item === selected;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', String(active));
      });
      if (this.continueLink) {
        this.continueLink.href = selected.href;
        this.continueLink.setAttribute('aria-label', `Continue with ${selected.dataset.signTitle}`);
      }
      const summary = this.querySelector('[data-sign-selection]');
      const buttonName = this.querySelector('[data-sign-continue-name]');
      if (summary) summary.textContent = selected.dataset.signTitle;
      if (buttonName) buttonName.textContent = `with ${selected.dataset.signName}`;
    }

    updateScrollButtons() {
      const overflow = this.list.scrollWidth > this.list.clientWidth + 2;
      this.scrollButtons.forEach((button) => {
        button.hidden = !overflow;
        button.disabled = Number(button.dataset.signScroll) < 0
          ? this.list.scrollLeft <= 2
          : this.list.scrollLeft + this.list.clientWidth >= this.list.scrollWidth - 2;
      });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.initialized = false;
    }
  }

  customElements.define('fp-sign-catalog', SignCatalog);
})();
